import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { FolderItem, SelectedFileItem, BreadcrumbItem } from "@ServerTypes/folders/folders.schema";

export type { FolderItem, SelectedFileItem, BreadcrumbItem };

const refreshFileManagerSlice = createSlice({
  name: "refreshFileManager",
  initialState: false,
  reducers: {
    setRefreshFileManager: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

const selectedFilesSlice = createSlice({
  name: "selectedFiles",
  initialState: [] as SelectedFileItem[],
  reducers: {
    setSelectedFiles: (_state: SelectedFileItem[], action: PayloadAction<SelectedFileItem[]>) => action.payload,
  },
});

const currentFolderSlice = createSlice({
  name: "currentFolder",
  initialState: null as FolderItem | null,
  reducers: {
    setCurrentFolder: (_state: FolderItem | null, action: PayloadAction<FolderItem | null>) => {
      const payload = action.payload;
      return payload ? { ...payload } : null;
    },
    emptyCurrentFolder: () => null,
  },
});

const fileManagerBreadCrumbSlice = createSlice({
  name: "fileManagerBreadCrumb",
  initialState: [] as BreadcrumbItem[],
  reducers: {
    setFileManagerBreadCrumbData: (_state: BreadcrumbItem[], action: PayloadAction<BreadcrumbItem[]>) => action.payload,
  },
});

export const { setRefreshFileManager } = refreshFileManagerSlice.actions;
export const { setSelectedFiles } = selectedFilesSlice.actions;
export const { setCurrentFolder, emptyCurrentFolder } = currentFolderSlice.actions;
export const { setFileManagerBreadCrumbData } = fileManagerBreadCrumbSlice.actions;

export const refreshFileManager = refreshFileManagerSlice.reducer;
export const selectedFiles = selectedFilesSlice.reducer;
export const currentFolder = currentFolderSlice.reducer;
export const fileManagerBreadCrumb = fileManagerBreadCrumbSlice.reducer;
